module.exports = __webpack_public_path__ + "img/mariadb.811ea76f.svg";